import type { ReactNode } from 'react';

import FeatherIcon from 'components/base/FeatherIcon';
import { TruncatedText } from 'components/base/TruncatedText';

export interface DetailsHeaderProps {
  /** Feather icon name, the same one the object type has in the Workspace. */
  readonly icon: string;
  /** The object type, e.g. "Trigger". */
  readonly kind: string;
  /** Absent until the record has loaded. */
  readonly name?: string;
  /** Right-aligned, before the close button: typically an actions dropdown. */
  readonly actions?: ReactNode;
  readonly onClose: () => void;
}

/** One line naming the object, with its actions and the close button at the end. */
export const DetailsHeader = ({ icon, kind, name, actions, onClose }: DetailsHeaderProps) => (
  <div className="details-header">
    <div className="details-header__title">
      <FeatherIcon icon={icon} size={18} className="details-header__icon" />
      <span className="details-header__kind">{kind}</span>
      {name !== undefined && (
        <>
          <span className="details-header__kind">–</span>
          <span className="details-header__name">
            <TruncatedText text={name} />
          </span>
        </>
      )}
    </div>
    {actions}
    <button type="button" className="btn-close" aria-label="Close details" onClick={onClose} />
  </div>
);
